import { render, staticRenderFns } from "./MCSSQuestion.vue?vue&type=template&id=2da383ad&"
import script from "./MCSSQuestion.vue?vue&type=script&lang=js&"
export * from "./MCSSQuestion.vue?vue&type=script&lang=js&"
import style0 from "./MCSSQuestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports